// src/utils/index.ts
function objToStyle(object = {}) {
  let style = "";
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      style += `${key}: ${object[key]};`;
    }
  }
  return style;
}

// src/Captcha.ts
var SLIDE = "slide";
var TEXT = "text";
var ROTATE = "rotate";
var Captcha = class {
  constructor(option) {
    this.captchaIframe = {
      slide: "https://app.litenews.cn/service2/dev-page/captcha-iframe/slide/index.html",
      text: "https://app.litenews.cn/service2/dev-page/captcha-iframe/text/index.html",
      rotate: "https://app.litenews.cn/service2/dev-page/captcha-iframe/rotate/index.html"
    };
    this.defaultMode = SLIDE;
    this.presetStyle = {
      position: "fixed",
      left: "0",
      right: "0",
      top: "0",
      bottom: "0",
      margin: "auto",
      overflow: "hidden",
      padding: "5px 10px",
      display: "block",
      width: "310px",
      height: "247px",
      background: "#FFFFFF",
      border: "none",
      visibility: "hidden",
      "box-shadow": "0px 1px 8px 0px rgba(174,178,180,0.3800)",
      "border-radius": "15px",
      "z-index": 2078
    };
    this.maskStyle = {
      position: "fixed",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      "background-color": "#000",
      visibility: "hidden",
      opacity: 0.7,
      "z-index": 2077
    };
    this.init(option);
  }
  static getInstance(option) {
    if (option.mode === TEXT) {
      if (!Captcha.textInstance) {
        Captcha.textInstance = new Captcha(option);
      }
      return Captcha.textInstance;
    } else if (option.mode === ROTATE) {
      if (!Captcha.rotateInstance) {
        Captcha.rotateInstance = new Captcha(option);
      }
      return Captcha.rotateInstance;
    } else {
      if (!Captcha.slideInstance) {
        Captcha.slideInstance = new Captcha(option);
      }
      return Captcha.slideInstance;
    }
  }
  init(option) {
    if (option.zIndex) {
      this.presetStyle["z-index"] = option.zIndex;
      this.maskStyle["z-index"] = option.zIndex - 1;
    }
    this.setIframe(option);
    this.setMask(option);
  }
  setIframe(option) {
    const iframe = document.createElement("iframe");
    const mode = (option == null ? void 0 : option.mode) || this.defaultMode;
    iframe.src = this.captchaIframe[mode];
    if (option.appid) {
      iframe.src += `?appid=${option.appid}`;
    }
    if (mode === TEXT) {
      this.presetStyle.height = "290px";
    }
    iframe.setAttribute("style", objToStyle(this.presetStyle));
    this.iframe = iframe;
    document.body.appendChild(iframe);
    const that = this;
    iframe.onload = function() {
      window.onmessage = (e) => {
        if (e.data.error) {
          option == null ? void 0 : option.onVerify({
            error: "error"
          });
        }
        if (e.data.result) {
          option == null ? void 0 : option.onVerify({
            result: e.data.result
          });
          that.verifyData = e.data.result.data;
        }
        if (e.data.close) {
          that.close();
          option == null ? void 0 : option.onClose(e.data.close);
        }
      };
    };
  }
  setMask(option) {
    const mask = document.createElement("div");
    mask.setAttribute("style", objToStyle(this.maskStyle));
    this.mask = mask;
    document.body.appendChild(mask);
  }
  refresh() {
    ;
    this.iframe.src = this.iframe.src;
  }
  open() {
    this.iframe.style.visibility = "visible";
    this.mask.style.visibility = "visible";
  }
  close() {
    this.iframe.style.visibility = "hidden";
    this.mask.style.visibility = "hidden";
  }
  destroy() {
    document.body.removeChild(this.iframe);
    document.body.removeChild(this.mask);
    Captcha.slideInstance = null;
    Captcha.textInstance = null;
    Captcha.rotateInstance = null;
  }
  getVerifyData() {
    return this.verifyData || "";
  }
};

// src/index.ts
function createCaptcha(option) {
  return Captcha.getInstance(option);
}
export {
  createCaptcha
};
//# sourceMappingURL=index.mjs.map